import React from 'react';

const Success = () => (
  <div className="h-signUpMessage font-semibold text-2xl">
    Thank you for signing up - you will hear from us soon!
  </div>
);

export default Success;
